(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/private-route/private-route.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/private-route/private-route.js');
"use strict";

const _excluded = ["component"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const _svs$app$ReactRouter = svs.app.ReactRouter,
  Route = _svs$app$ReactRouter.Route,
  Redirect = _svs$app$ReactRouter.Redirect;
const _ref = svs.ticket_partner.constants.routes || {},
  LOGIN = _ref.LOGIN;
const PrivateRoute = _ref2 => {
  let Component = _ref2.component,
    rest = _objectWithoutProperties(_ref2, _excluded);
  const _svs$ticket_partner$u = svs.ticket_partner.useUserContext(),
    isLoggedIn = _svs$ticket_partner$u.isLoggedIn;
  return React.createElement(Route, _extends({
    component: props => {
      if (isLoggedIn) {
        return React.createElement(Component, props);
      }
      return React.createElement(Redirect, {
        to: "".concat(LOGIN, "?returnUrl=").concat(rest.path)
      });
    }
  }, rest));
};
svs.ticket_partner.sharedComponents.privateRoute.PrivateRoute = PrivateRoute;

 })(window);